import { t } from "@lingui/macro"

import sv from "date-fns/locale/sv"
import enGB from "date-fns/locale/en-GB"
import fi from "date-fns/locale/fi"
import da from "date-fns/locale/da"
import type { Locale as DateFnsLocale } from "date-fns"

import gbFlag from "src/assets/images/gb-flag.png"
import svFlag from "src/assets/images/sv-flag.png"
import fiFlag from "src/assets/images/fi-flag.png"

export enum Locale {
    English = "en",
    Swedish = "sv",
    Finnish = "fi",
    Danish = "da",
}

export interface ILocale {
    key: Locale
    icon: string
    dateFnsLocale: DateFnsLocale
    name: string
    hidden?: boolean
}

export const Locales: { [k in Locale]: ILocale } = {
    [Locale.English]: {
        key: Locale.English,
        icon: gbFlag,
        dateFnsLocale: enGB,
        // Lazily evaluate as `t` cannot be called a import time.
        get name() {
            return t`global.english`
        },
    },
    [Locale.Swedish]: {
        key: Locale.Swedish,
        icon: svFlag,
        dateFnsLocale: sv,
        // Lazily evaluate as `t` cannot be called a import time.
        get name() {
            return t`global.swedish`
        },
    },
    [Locale.Finnish]: {
        key: Locale.Finnish,
        icon: fiFlag,
        dateFnsLocale: fi,
        // Lazily evaluate as `t` cannot be called a import time.
        get name() {
            return t`global.finnish`
        },
    },
    [Locale.Danish]: {
        key: Locale.Danish,
        icon: fiFlag,
        dateFnsLocale: da,
        // Lazily evaluate as `t` cannot be called at import time.
        get name() {
            return t`global.danish`
        },
        hidden: true, // hide danish from the language selector
    },
}
